import React from "react";

function TextWidget(props) {
  var BaseInput = props.registry.widgets.BaseInput;
  return /*#__PURE__*/React.createElement(BaseInput, props);
}

if (process.env.NODE_ENV !== "production") {}

export default TextWidget;